module.exports = __webpack_public_path__ + "img/ander3.7befe2ff.jpg";